export default function CTABanner() {
  return (
    <section className="relative w-full h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20fashion%20lifestyle%20still%20life%20with%20sneakers%20hoodie%20and%20accessories%20arranged%20on%20a%20minimal%20surface%20surrounded%20by%20soft%20dried%20pampas%20grass%20and%20warm%20toned%20linen%20fabric%20textures%20natural%20golden%20sunlight%20creating%20gentle%20highlights%20creamy%20beige%20and%20warm%20sand%20color%20palette%20artistic%20editorial%20composition%20elegant%20minimal%20aesthetic&width=1920&height=1200&seq=cta-banner-v2-2026&orientation=landscape"
          alt="Explore the Best Pandabuy Spreadsheet Now"
          title="Pandabuy Spreadsheet - Start Exploring Now"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4">
        <h2 className="font-heading text-[42px] md:text-[64px] lg:text-[80px] leading-[1.05] text-background-50 font-bold tracking-[-0.02em] max-w-[800px] mx-auto">
          START EXPLORING THE BEST PANDABUY SPREADSHEET NOW
        </h2>
        <p className="mt-6 text-[16px] md:text-[18px] text-background-50/80 leading-relaxed font-body max-w-[560px] mx-auto">
          Access our fully curated Pandabuy spreadsheet database with 10,000+ verified product
          links updated daily
        </p>
        <div className="mt-10 flex justify-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="relative inline-flex items-center gap-3 px-8 py-4 bg-foreground-950 text-background-50 text-[15px] font-label font-bold rounded-full hover:bg-foreground-900 transition-all duration-300 whitespace-nowrap cursor-pointer group"
          >
            <span className="w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center -ml-2">
              <i className="ri-shopping-bag-line text-background-50 text-base"></i>
            </span>
            <span>Buy It Now</span>
            <i className="ri-arrow-right-up-line text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300"></i>
          </a>
        </div>
      </div>
    </section>
  );
}